import type { FC } from "react";
import React from "react";

export const Space: FC = () => <span> </span>;
